<button (click)="onClick()" [disabled]="is_inquiry_loading" class="view-btn d-flex" style="justify-self:center;">
    <div
        *ngIf="is_inquiry_loading"
        class="head_drop_serc_oncli_ban"
        style="cursor: progress; margin-right: 0.3rem"
      >
        <div
          class="spinner-border"
          style="height: 1rem; width: 1rem"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    {{ label }}
  </button>